import React, {memo, useState, useEffect} from "../../../../__snowpack__/pkg/react.js";
import {Modal, Button, Progress, Spin, Table} from "../../../../__snowpack__/pkg/antd.js";
import {axios} from "../../../lib/axios.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import {eventLogger} from "../../../lib/eventLogger.js";
import {IconSuccess, IconError} from "../../../../__snowpack__/pkg/@genieui-react/icon.js";
import ChannelIcon from "../../ChannelIcon.js";
const ModalStyled = styled(Modal)``;
export const ResultModal = memo((props) => {
  const {CopyTaskInfo, IsSuccessVisible, onViewNow, channelId} = props;
  const {formatMessage} = useIntl();
  const [IsLoading, setIsLoading] = useState(false);
  const [batchFailList, setBatchFailList] = useState([]);
  const handelViewNow = () => {
    if (progressResults === "SUCCESS") {
      eventLogger.push({
        action: "ClickViewNow",
        location: "BatchEditSucceedResultPopup"
      });
    } else if (progressResults === "PART_FAILED") {
      eventLogger.push({
        action: "ClickViewFailedList",
        location: "BatchEditSomeFailedResultPopup"
      });
      setProgressResults("PART_FAILED");
    } else {
      eventLogger.push({
        action: "ClickViewFailedList",
        location: "BatchEditFailedResultPopup"
      });
      setProgressResults("FAILED");
    }
    onViewNow && onViewNow();
  };
  let ScrapingTimer = null;
  const [percentNum, setPercentNum] = useState(10);
  const [progressResults, setProgressResults] = useState("");
  const getProgressResults = async () => {
    try {
      const data = await axios.get(`/saas/product/batch_product_result/${CopyTaskInfo.taskId}`);
      if (data.code === "SUCCESS") {
        if (data.data.status !== "FINISHED") {
          ActualTimeApi();
        } else {
          if (data.data.successTotal === data.data.total) {
            eventLogger.push({
              action: "Page",
              location: "BatchEditSucceedResultPopup"
            });
            setProgressResults("SUCCESS");
          } else if (data.data.failTotal !== data.data.total) {
            eventLogger.push({
              action: "Page",
              location: "BatchEditSomeFailedResultPopup"
            });
            setProgressResults("PART_FAILED");
          } else {
            eventLogger.push({
              action: "Page",
              location: "BatchEditFailedResultPopup"
            });
            setProgressResults("FAILED");
          }
          let Percent = (data.failTotal + data.successTotal) / data.totalCount * 100;
          setPercentNum(data.data.status === "FINISHED" ? 100 : Percent < 10 ? 10 : Percent);
          setBatchFailList(data.data.batchProductShopResultVOList || []);
        }
      } else {
        setProgressResults("FAILED");
        setPercentNum(100);
        clearInterval(ScrapingTimer);
      }
    } catch (error) {
      setProgressResults("FAILED");
      setPercentNum(100);
      clearInterval(ScrapingTimer);
    }
  };
  useEffect(() => {
    if (CopyTaskInfo.taskId) {
      ActualTimeApi();
    }
  }, []);
  const handelCancelResults = (type) => {
    clearInterval(window.timer);
    props.handelCancelResults();
  };
  const ActualTimeApi = () => {
    setTimeout(() => {
      getProgressResults();
    }, 1e3);
  };
  useEffect(() => {
    if (CopyTaskInfo.taskId) {
      setPercentNum(10);
      setProgressResults("");
      setTimeout(() => {
        ActualTimeApi();
      }, 1e3);
    }
  }, [CopyTaskInfo]);
  return /* @__PURE__ */ React.createElement(ModalStyled, {
    title: formatMessage({id: "result"}),
    footer: null,
    width: 490,
    bodyStyle: {padding: "16px 24px"},
    onCancel: () => handelCancelResults(false),
    visible: IsSuccessVisible
  }, /* @__PURE__ */ React.createElement("p", null, progressResults), progressResults === "SUCCESS" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconSuccess, {
    style: {float: "left"}
  }), /* @__PURE__ */ React.createElement("div", {
    style: {paddingLeft: 30, lineHeight: "24px"}
  }, formatMessage({id: "publishSucceeded"}))), progressResults === "PART_FAILED" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconError, {
    style: {float: "left"}
  }), /* @__PURE__ */ React.createElement("div", {
    style: {paddingLeft: 30, lineHeight: "24px"}
  }, formatMessage({id: "productUpdateFailed"}))), progressResults === "FAILED" && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IconError, {
    style: {float: "left"}
  }), /* @__PURE__ */ React.createElement("div", {
    style: {paddingLeft: 30, lineHeight: "24px"}
  }, formatMessage({id: "publishFailed"}))), /* @__PURE__ */ React.createElement(Progress, {
    status: "active",
    percent: percentNum,
    showInfo: false,
    strokeColor: {
      from: "#B699FF",
      to: "#4C04FF"
    },
    size: "default"
  }), /* @__PURE__ */ React.createElement(Spin, {
    spinning: IsLoading
  }, IsLoading ? /* @__PURE__ */ React.createElement("div", {
    style: {height: 200}
  }) : /* @__PURE__ */ React.createElement(CloneResultsModalStyled, {
    className: "results-content"
  }, progressResults && /* @__PURE__ */ React.createElement(Table, {
    scroll: {y: 300},
    dataSource: batchFailList || [],
    style: {margin: "16px 0 0 0"},
    pagination: false
  }, /* @__PURE__ */ React.createElement(Table.Column, {
    width: "40%",
    title: formatMessage({id: "storeNameA"}),
    render: (active, record, index) => {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ChannelIcon, {
        channelId
      }), /* @__PURE__ */ React.createElement("span", {
        style: {paddingLeft: "6px"}
      }, record?.shopName));
    }
  }), /* @__PURE__ */ React.createElement(Table.Column, {
    dataIndex: "successCount",
    title: formatMessage({id: "successNumber"}),
    render: (active, record, index) => {
      return /* @__PURE__ */ React.createElement("span", {
        style: {color: "#66BE75"}
      }, active);
    }
  }), /* @__PURE__ */ React.createElement(Table.Column, {
    dataIndex: "failCount",
    title: formatMessage({id: "failedNumber"}),
    render: (active, record, index) => {
      return /* @__PURE__ */ React.createElement("span", {
        style: {color: "#E7192C"}
      }, active);
    }
  })), /* @__PURE__ */ React.createElement("div", {
    className: "results-content-btn"
  }, /* @__PURE__ */ React.createElement(Button, {
    onClick: () => handelCancelResults(false),
    style: {marginRight: 16}
  }, formatMessage({id: "close"}))))));
});
const CloneResultsModalStyled = styled.div`
  .count-table {
    width: 100%;
    tbody {
      max-height: 300px;
      overflow-y: auto;
    }
    td {
      border: 1px solid #e8e8e8;
    }
  }
  .count-label,
  .count-value {
    padding: 10px;
  }
  .count-table .count-label {
    width: 200px;
    font-weight: bold;
    color: #161344;
    border-top: none;
    border-left: none;
  }
  .count-table .count-value {
    border-top: none;
    border-left: none;
  }
  .count-table .success-value {
    color: #66be75;
  }
  .count-table .failed-value {
    color: #e7192c;
  }
  .count-table tr td:last-child {
    border-right: none;
  }
  .count-value {
    text-align: left;
    width: 200px;
  }
  .result-message {
    display: inline-block;
  }
  .results-content {
    &-success {
      margin-top: 24px;
      margin-bottom: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      b {
        display: inline-block;
        padding-top: 16px;
        font-size: 16px;
      }
    }
    &-list {
      background: rgba(245, 245, 245, 0.5);
      padding: 24px;
      /* margin-left: 30px;
      margin-right: 30px; */
      .list-item {
        display: flex;
        justify-content: flex-start;
        font-size: 14px;
        color: #5a6977;
        .store-name {
          text-align: right;
          width: 150px;
        }
        .success-desc {
          padding-left: 16px;
          .success-count-green {
            color: #52c41a;
            padding-right: 4px;
          }
          .success-tip {
            color: #5a6977;
          }
        }
      }
    }
    &-btn {
      margin-top: 24px;
      text-align: center;
    }
  }
`;
